import { onlineManager } from '@tanstack/react-query';

/**
 * TanStack Query's onlineManager starts out "online" and only changes on
 * `online`/`offline` events — a page (re)loaded with no network never gets
 * an `offline` event, so every query and queued desk event would try the
 * network, fail, and burn retries (desk events would even park after 8).
 * Seed it from `navigator.onLine` at boot; the events keep it current after
 * that. Task 14 fix round 1 — found by the offline-reload browser check.
 */
export function seedOnlineState(nav: Pick<Navigator, 'onLine'> | undefined = globalThis.navigator): void {
  if (nav && typeof nav.onLine === 'boolean') onlineManager.setOnline(nav.onLine);
}
